<script lang="ts">
  /* Search, over the stations and notes already loaded to draw the chart. */
  import SearchPanelUI from '@gennetay/chart-ui/panels/SearchPanel';
  import { layout } from '@gennetay/chart-ui/shell';
  import { searchIndex } from '../searchindex.svelte';
  import { flyTo } from '../camera.svelte';
  import { geocode } from '../geocode';

  /* Rebuilt per keystroke rather than cached: the stations arrive as the packs
     load, the notes change as the chart is panned, and `detail` is a live
     reading. A few hundred rows is nothing, and a stale index that looks fresh
     is a fault this app has been bitten by elsewhere. */
  const items = $derived(searchIndex());
</script>

<SearchPanelUI
  {items}
  {geocode}
  autofocus={!layout.phone}
  onpick={(p) => flyTo(p.lat, p.lon)}
/>
